import { LOCAL_STORAGE_KEYS } from "../utils/constants";
import { invokeApi } from "../bl_libs/invokeApi";
import { use_e2ee } from "../utils/utils";

/**
 * Email log — every email the platform sent (EmailOutbox in my-dq-api), with
 * who it went to, each attempt, and the outcome; a resend; and cancelling an
 * email held until its school or class is published.
 *
 * Search, filters and paging all run on the server. The list never carries
 * an email's body (it can hold activation links).
 */
export const listEmails = ({ search = '', status = '', template = '', from_date = '', to_date = '', page = 0, rows_per_page = 25 } = {}) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/emails/list',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { search, status, template, from_date, to_date, page, rows_per_page },
    }, use_e2ee());
};

/**
 * Send a logged email again, exactly as it went out, as a new log row.
 * `to` is optional: given, it replaces the recipients and the cc list is not
 * copied; omitted, the email goes to its original to and cc.
 */
export const resendEmail = ({ email_id, to }) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/emails/resend',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { email_id, ...(to ? { to } : {}) },
    }, use_e2ee());
};

/**
 * Cancel an email held until its school or class is published, so the publish
 * does not send it. Only a held email can be cancelled.
 */
export const cancelEmail = ({ email_id, reason = '' }) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/emails/cancel',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { email_id, ...(reason ? { reason } : {}) },
    }, use_e2ee());
};

/** EmailOutbox.status (EMAIL_OUTBOX_STATUS in my-dq-api). */
export const EMAIL_OUTBOX_STATUS = {
    HELD: 0,
    SENDING: 1,
    SENT: 5,
    CANCELLED: 8,
    FAILED: 9,
};

export const STATUS_LABEL = {
    0: 'Held',
    1: 'Sending',
    5: 'Sent',
    8: 'Cancelled',
    9: 'Failed',
};

export const STATUS_COLOR = {
    0: { fg: '#8a5300', bg: '#fff6e5' },
    1: { fg: '#0b5fa5', bg: '#e8f1fa' },
    5: { fg: '#1b6b3a', bg: '#e7f4ec' },
    8: { fg: '#555555', bg: '#eeeeee' },
    9: { fg: '#a33224', bg: '#fbecea' },
};

/** Dropdown options. The empty value means "all", which the server ignores. */
export const STATUS_FILTERS = [
    { value: '', label: 'All statuses' },
    { value: String(EMAIL_OUTBOX_STATUS.FAILED), label: 'Failed' },
    { value: String(EMAIL_OUTBOX_STATUS.HELD), label: 'Held until published' },
    { value: String(EMAIL_OUTBOX_STATUS.SENT), label: 'Sent' },
    { value: String(EMAIL_OUTBOX_STATUS.SENDING), label: 'Sending' },
    { value: String(EMAIL_OUTBOX_STATUS.CANCELLED), label: 'Cancelled' },
];
